import { render } from "./header-nav.vue?vue&type=template&id=5a55050c"
import script from "./header-nav.vue?vue&type=script&lang=js"
export * from "./header-nav.vue?vue&type=script&lang=js"
script.render = render

export default script